export const HorizontalDivider = () => {
  return <hr className="h-px w-1/2 border-0 bg-slate-200 md:max-w-sm" />;
};
